import React from "react";

import type { JSX } from "react"

export type AvailableIcons =
    | 'ArrowsPointingOut'
    | 'Bandeira do Brasil'
    | 'BannerChevronLeft'
    | 'BannerChevronRight'
    | 'Calendário'
    | 'Caminhão'
    | 'Cartões de Crédito'
    | 'Check'
    | 'ChevronDown'
    | 'ChevronLeft'
    | 'ChevronRight'
    | 'ChevronUp'
    | 'CloseTelevendas'
    | 'CoraçãoVitrine'
    | 'CreditCard'
    | 'Deco'
    | 'Desconto'
    | 'Diners'
    | 'Discord'
    | 'Discount'
    | 'E-Plus'
    | 'Elo'
    | 'Envelope'
    | 'Facebook'
    | 'FacebookFilled'
    | 'Fale Conosco'
    | 'FilledChevronDown'
    | 'FilledChevronLeft'
    | 'FilledChevronRight'
    | 'FilterList'
    | 'FooterBlog'
    | 'FooterFacebook'
    | 'FooterInstagram'
    | 'FooterTiktok'
    | 'FooterTwitter'
    | 'FooterX'
    | 'FooterYoutube'
    | 'Heart'
    | 'Instagram'
    | 'Linkedin'
    | 'Login'
    | 'MagnifyingGlass'
    | 'MapPin'
    | 'Mastercard'
    | 'Menu'
    | 'Message'
    | 'Minus'
    | 'NextPage'
    | 'PDPEmail'
    | 'PDPX'
    | 'Pedidos'
    | 'Phone'
    | 'PinterestFilled'
    | 'Pix'
    | 'Plus'
    | 'PreviousPage'
    | 'QuestionMarkCircle'
    | 'Return'
    | 'Revendedor'
    | 'Ruler'
    | 'Sacola'
    | 'Sao Paulo'
    | 'Share'
    | 'ShoppingCart'
    | 'Star'
    | 'StarOutline'
    | 'Telephone'
    | 'Televendas'
    | 'Tiktok'
    | 'Trash'
    | 'Truck'
    | 'TruckPDP'
    | 'Twitter'
    | 'TwitterFilled'
    | 'User'
    | 'Visa'
    | 'Vtex'
    | 'WhatsApp'
    | 'WhatsappFilled'
    | 'X'
    | 'XMark'
    | 'Zoom'
    | 'GlossaryArrow'
    | 'GlossarySearch'
    | 'MyVibHeart'
    | 'MyVibDrop'
    | 'MyVibFire'
    | 'MyVibBag'
    | 'MyVibHeartHover'
    | 'MyVibDropHover'
    | 'MyVibFireHover'
    | 'MyVibBagHover'

export interface Props extends React.SVGAttributes<SVGSVGElement> {
    /**
     * Symbol id from element to render. Take a look at `/static/icons.svg`.
     *
     * Example: <Icon id="Bell" />
     */
    id: AvailableIcons
    size?: number
}

function Icon({ id, strokeWidth = 0, size, width, height, ...props }: Props) {
    return (
        <svg {...props} width={width ?? size} height={height ?? size} strokeWidth={strokeWidth}>
            <use href={`/sprites.svg#${id}`} />
        </svg>
    )
}

export default Icon
